var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChromaticCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1601 5.04102L13.3761 8.82502C13.9037 9.38223 14.2157 10.1091 14.2561 10.8754H19.6065C19.5757 8.68754 18.6989 6.59657 17.1601 5.04102Z",
    fill: "#FFCE54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9575 4.86523L15.0743 6.75723L16.9575 4.86523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2215 4.77745C17.1945 4.74595 17.165 4.71654 17.1335 4.68945L17.2215 4.77745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9664 17.1591C15.4024 18.6872 13.3097 19.5539 11.1232 19.5791V14.2023C11.8895 14.1618 12.6164 13.8499 13.1736 13.3223L15.0744 15.2143L15.1536 15.1263L15.0744 15.2143L16.9664 17.1591Z",
    fill: "#37BC9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0743 15.2416L13.1735 13.3496L15.0743 15.2416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9663 17.1322L15.0743 15.2402L16.9663 17.1322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8768 14.2022V19.5526C8.69627 19.5359 6.60631 18.6785 5.04236 17.159L6.93436 15.267L8.82636 13.375C9.39122 13.8834 10.1173 14.1763 10.8768 14.2022Z",
    fill: "#5D9CEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69031 17.1598L4.77831 17.2478C4.74681 17.2207 4.71739 17.1913 4.69031 17.1598ZM6.75831 15.0742L6.84631 15.1534L6.75831 15.0742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04236 4.83891L6.92556 6.75731L6.84636 6.84531L6.92556 6.75731L8.82636 8.64931C9.38357 8.1217 10.1104 7.80974 10.8768 7.76931V2.44531C8.69627 2.462 6.60631 3.31942 5.04236 4.83891Z",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.77831 4.77734L4.69031 4.86534L4.77831 4.77734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7584 6.92404V6.93284L5.0072 5.18164L6.7584 6.92404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93436 6.75723L5.04236 4.86523L6.93436 6.75723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57122 8.74639L6.75842 6.93359L8.57122 8.74639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82633 8.64981L6.93433 6.75781L8.82633 8.64981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5537 11.123C19.537 13.3035 18.6796 15.3935 17.1601 16.9574L15.2681 15.0742L13.3761 13.1734C13.9037 12.6162 14.2157 11.8894 14.2561 11.123H19.5537Z",
    fill: "#A0D468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1535 15.1523L15.0743 15.2403L15.1535 15.1523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65041 8.82502C8.1228 9.38223 7.81083 10.1091 7.77041 10.8754H2.44641C2.46309 8.69493 3.32051 6.60497 4.84001 5.04102L4.98961 5.18182L6.74961 6.94182L6.83761 6.86262L6.74961 6.94182L8.57121 8.74582L8.65041 8.82502Z",
    fill: "#EC87C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83995 4.68945L4.75195 4.77745L4.83995 4.68945ZM2.19995 10.9991V11.1223V10.9991ZM6.92555 6.75745L6.84635 6.84545L6.75835 6.92465L6.84635 6.84545L6.92555 6.75745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65041 13.1734C8.1228 12.6162 7.81083 11.8894 7.77041 11.123H2.44641C2.46309 13.3035 3.32051 15.3935 4.84001 16.9574L6.73201 15.0742L6.82001 15.1534L6.73201 15.0742L8.62401 13.1734H8.65041Z",
    fill: "#AC92EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9576 4.83891L13.1736 8.62291C12.6164 8.0953 11.8895 7.78334 11.1232 7.74291V2.44531C13.3037 2.462 15.3936 3.31942 16.9576 4.83891Z",
    fill: "#FC6E51"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.25,
    style: {
      stroke: "var(--ringColor)"
    },
    strokeWidth: 1.5
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6,
    height: 17.6,
    fill: "white",
    transform: "translate(2.19995 2.19922)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromaticCircle);
export default __webpack_public_path__ + "static/media/chromatic-circle.da8cb39bbec8807e5fed247f3d31589d.svg";
export { ForwardRef as ReactComponent };